import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('extract_rovo_agent_configuration_package');
	},
};
